import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgEuro = (props) => (
  <SvgIcon {...props} title="Euro">
    <svg
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.568.354C2.446 1.27-2.4 10.182 1.213 17.559c4.383 8.953 17.17 8.953 21.553 0C26.926 9.063 19.996-.71 10.568.354Zm2.89 1.672c7.314 1.005 11.24 9.393 7.344 15.69-4.308 6.966-14.63 6.422-18.146-.956C-.897 9.304 5.263.9 13.458 2.026ZM11.99 5.17c-.879.23-1.664.857-2.041 1.63-.344.703-.354.782-.354 2.849v1.838H9.06c-.783 0-1.06.21-1.06.8 0 .59.277.799 1.063.8h.54l-.016 1.286c-.02 1.592-.106 1.801-.78 1.885-.848.105-1.14 1.102-.446 1.526.254.155 7.005.155 7.259 0 .492-.301.492-1.1 0-1.4-.156-.095-.255-.1-2.35-.1-2.067 0-2.186-.005-2.146-.087.023-.048.05-.768.058-1.6l.016-1.51h1.332c1.667-.001 1.855-.082 1.855-.8 0-.72-.187-.8-1.862-.8h-1.337l.015-1.761.016-1.761.13-.278c.72-1.537 2.85-1.148 3.016.552.12 1.219 1.617 1.171 1.618-.052.001-1.993-2.032-3.53-3.99-3.017Z"
        fill="#017163"
      />
    </svg>
  </SvgIcon>
);

export default SvgEuro;
